/**
 * Auth Modal Component
 * Premium gold-themed modal wrapper for landing page auth forms.
 * Uses HTML5 <dialog> for built-in focus trapping, escape key, and accessibility.
 */

import React, { useEffect, useRef, useCallback } from 'react';

function AuthModal({ isOpen, onClose, children }) {
  const dialogRef = useRef(null);

  // Sync dialog open/close state with isOpen prop
  useEffect(() => {
    const dialog = dialogRef.current;
    if (!dialog) return;

    if (isOpen && !dialog.open) {
      dialog.showModal();
    } else if (!isOpen && dialog.open) {
      dialog.close();
    }
  }, [isOpen]);

  // Handle native dialog close (escape key)
  const handleCancel = useCallback((e) => {
    e.preventDefault();
    onClose();
  }, [onClose]);

  // Handle backdrop click
  const handleBackdropClick = useCallback((e) => {
    const dialog = dialogRef.current;
    if (e.target === dialog) {
      onClose();
    }
  }, [onClose]);

  return (
    <dialog
      ref={dialogRef}
      className="auth-modal-dialog"
      onCancel={handleCancel}
      onClick={handleBackdropClick}
      aria-label="Sign in or create account"
    >
      <div className="auth-modal-content" onClick={(e) => e.stopPropagation()}>
        <button
          className="auth-modal-close"
          onClick={onClose}
          aria-label="Close"
          type="button"
        >
          <i className="fas fa-times"></i>
        </button>
        {children}
      </div>
    </dialog>
  );
}

export default AuthModal;
